import * as analytics from '@opendoor/shared-fe/build/analytics';
import { createSlice } from '@reduxjs/toolkit';

import type { FlowQuestion } from 'src/lib/flow/FlowQuestion';

import { getFlow } from '../helpers/flows';
import { api } from './api';

export type JsonFlowPage = {
  slug: string;
  title: string;
  subtitle?: string;
  subflow_name?: string;
  hidden?: boolean | string;
  carrot?: string;
  next_text?: string;
  questions?: Array<FlowQuestion>;
  note?: string;
  show_privacy_notice?: boolean;
  last_carrot?: boolean;
  hide_progress_bar?: boolean;
  image?: string;
  tooltip?: string;
};

type SubFlow = {
  $schema: string;
  name: string;
  pages: Array<JsonFlowPage>;
};

type FlowData = {
  pages: Array<JsonFlowPage>;
};

export type FlowState = {
  name: string | null;
  uuid: string;
  data: FlowData;
  subflows: Array<SubFlow>;
};

const slice = createSlice({
  name: 'flow',
  initialState: {
    uuid: '',
    data: { pages: [] },
    name: null,
    subflows: [],
  } as FlowState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(api.endpoints.getSellerInputs.matchFulfilled, (state, { payload }) => {
      if (payload.reception?.getSellerInput?.sellerInput) {
        const { address, sellerFlowUuid, uuid, sellerFlowName } =
          payload.reception.getSellerInput.sellerInput;

        if (address) {
          const { data, name, subflows } = getFlow(sellerFlowName);

          //TODO: type getFlow correctly so this is not needed
          state.data = data as FlowData;
          state.uuid = sellerFlowUuid;
          state.name = name;
          state.subflows = subflows as Array<SubFlow>;

          analytics.trackEvent('seller-flow', 'view', '', {
            lead_token: uuid,
            flow: name,
            use_local_config: true,
          });
        }
      }
    });
  },
});

export default slice.reducer;
